import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { User, EntityType } from 'api'
import { Selectbox, SelectboxProps } from 'view/components/options'
import { Field } from 'view/components/inputs'
import { DecisionMakerHelper } from 'model'
import { decisionMakerUserIdsSelector, createOrganisationDecisionMakerUserIdsSelector } from 'selectors/userSelectors'
import { createEntityGetterSelector } from 'selectors/entitySelectors'

export interface OrganisationDecisionMakerSelectboxProps extends SelectboxProps<User, string> {
  organisationId: string | null
}

const organisationDecisionMakerOrganisationIdSelector = (_: {}, props: OrganisationDecisionMakerSelectboxProps) => props.organisationId

const organisationDecisionMakerMapStateToProps = createStructuredSelector({
  optionKeys: createOrganisationDecisionMakerUserIdsSelector(organisationDecisionMakerOrganisationIdSelector),
  getOption: createEntityGetterSelector(EntityType.USER)
})

const OrganisationDecisionMakerSelectboxComponent = React.forwardRef(
  (props: OrganisationDecisionMakerSelectboxProps, ref: React.Ref<Selectbox>) => {
    const { optionKeys, getOption, ...rest } = props
    return <Selectbox ref={ref} optionKeys={optionKeys} getOption={getOption} getOptionText={DecisionMakerHelper.getName} {...rest} />
  }
)

export const OrganisationDecisionMakerSelectbox = connect(organisationDecisionMakerMapStateToProps, null, null, { forwardRef: true })(
  OrganisationDecisionMakerSelectboxComponent
) as React.ComponentType<Omit<OrganisationDecisionMakerSelectboxProps, 'optionKeys' | 'getOption'>>

export const OrganisationDecisionMakerSelectboxField = Field(OrganisationDecisionMakerSelectbox)

type DecisionMakerSelectboxProps = SelectboxProps<User, string>

const decisionMakerMapStateToProps = createStructuredSelector({
  optionKeys: decisionMakerUserIdsSelector,
  getOption: createEntityGetterSelector(EntityType.USER)
})

const DecisionMakerSelectboxComponent = React.forwardRef((props: DecisionMakerSelectboxProps, ref: React.Ref<Selectbox>) => {
  const { optionKeys, getOption, ...rest } = props
  return <Selectbox ref={ref} optionKeys={optionKeys} getOption={getOption} getOptionText={DecisionMakerHelper.getName} {...rest} />
})

export const DecisionMakerSelectbox = connect(decisionMakerMapStateToProps, null, null, { forwardRef: true })(
  DecisionMakerSelectboxComponent
)

export const DecisionMakerSelectboxField = Field(DecisionMakerSelectbox)
